import debounce from 'debounce'

const mapEl = document.getElementById('map')
if (mapEl) {
	window.addEventListener('load', initMap)
}

function initMap() {
	const markers = _mapMarkers
	markers.forEach(marker => {
		let markerObj = {
			lat: parseFloat(marker.map_marker_location.latitude),
			lng: parseFloat(marker.map_marker_location.longitude),
		}
		marker['markerObj'] = markerObj
	})

	// Find center of multiple markers
	function findCenter(markers) {
		if (markers.length <= 1) {
			return markers[0].markerObj
		}
		const lats = markers.map(m => m.markerObj.lat)
		const lngs = markers.map(m => m.markerObj.lng)
		return {
			lat: (Math.min(...lats) + Math.max(...lats)) / 2,
			lng: (Math.min(...lngs) + Math.max(...lngs)) / 2,
		}
	}
	const centerPosition = findCenter(markers)

	var bounds = new google.maps.LatLngBounds()
	markers?.forEach(m => {
		bounds.extend(new google.maps.LatLng(m.markerObj.lat, m.markerObj.lng))
	})

	let zoomLevel
	if (window.innerWidth >= 1200) {
		zoomLevel = 15
	} else if (window.innerWidth >= 992) {
		zoomLevel = 14
	} else {
		zoomLevel = 13
	}

	const map = new google.maps.Map(document.getElementById('map'), {
		center: centerPosition,
		zoom: zoomLevel,
		mapId: 'f22f4f193b90ef3f',
		streetViewControl: false,
		mapTypeControl: false,
		fullscreenControl: false,
	})

	// map.setOptions({draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true});
	map.setOptions({ scrollwheel: false })

	const image = {
		url: '/wp-content/themes/custom-theme/assets/img/logo-map-marker.svg',
		size: new google.maps.Size(54, 41),
		origin: new google.maps.Point(0, 0),
		anchor: new google.maps.Point(27, 20),
	}

	for (let i = 0; i < markers.length; i++) {
		let m = markers[i]
		const contentString = `<div class="tooltip-content"><p><strong>${m.location_name}</strong></p><p><a href="${m.google_maps_link}" target="_blank">${m.address}</a></p></div>`

		const infowindow = new google.maps.InfoWindow({
			content: contentString,
		})

		let mrkr = new google.maps.Marker({
			position: m.markerObj,
			map,
			icon: image,
		})

		mrkr.addListener('click', () => {
			infowindow.open({
				anchor: mrkr,
				map,
				shouldFocus: false,
			})
		})
	}

	const refreshCenter = debounce(() => {
		// TODO: This is slightly annoying/unsightly when resizing the screen, clean it up if we have time
		map.setCenter(centerPosition)

		if (window.innerWidth < 992) {
			return
		}
		// retrieve the lat lng for the far extremities of the (visible) map
		var latLngBounds = map.getBounds()
		var neBound = latLngBounds.getNorthEast()
		var swBound = latLngBounds.getSouthWest()

		// convert the bounds in pixels
		var neBoundInPx = map.getProjection().fromLatLngToPoint(neBound)
		var swBoundInPx = map.getProjection().fromLatLngToPoint(swBound)

		var offset
		if (window.innerWidth >= 1900) {
			offset = (neBoundInPx.x - swBoundInPx.x) * 0.25
		} else if (window.innerWidth >= 992) {
			offset = (neBoundInPx.x - swBoundInPx.x) * 0.29
		}

		var center = map.getCenter()
		var centerPoint = map.getProjection().fromLatLngToPoint(center)
		centerPoint.x -= offset
		map.setCenter(map.getProjection().fromPointToLatLng(centerPoint))
	}, 100)

	const refreshBounds = () => {
		// TODO: This doesn't work properly when the map is partially obstructed by the contact card.
		// This also doesn't work properly with the centering function, as markers sometimes get pushed off screen
		// I think it has to do with the fact that centering is happening after the bounds are updated, and they don't take each other into account
		if (window.innerWidth <= 767) {
			if (markers.length > 1) map.fitBounds(bounds, 70)
		} else {
			if (markers.length > 1)
				map.fitBounds(bounds, {
					top: 120,
					right: 120,
					bottom: 120,
					left: window.innerWidth / 2 + 120,
				})
		}
	}

	map.addListener('projection_changed', () => {
		refreshBounds()
		refreshCenter()
	})

	window.addEventListener('resize', () => {
		refreshBounds()
		refreshCenter()
	})

	google.maps.event.addListenerOnce(map, 'idle', () => {
		refreshBounds()
		refreshCenter()
	})
}
